/* eslint-env browser */
import { Component, Input, OnInit, Output, EventEmitter,  OnDestroy, ChangeDetectorRef, ComponentRef, ViewContainerRef, signal } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Customer } from '@app/models/customers/Customer';
import { CruiseBooking } from '@app/models/kreuzfahrts/CruiseBooking';
import { CruiseCatalog } from '@app/models/kreuzfahrts/CruiseCatalog';
import { CruiseOfferCabin } from '@app/models/kreuzfahrts/CruiseOfferCabin';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { CruiseService } from '@app/services/cruise.service';
import { EncryptionService } from '@app/services/encyption.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { formatNumber } from '@angular/common';
import { CruiseOfferFIlter } from '@app/models/filtermodels/CruiseOfferFIlter';
import { Partner } from '@app/models/partner/IPartner';
import { CruisDetailComponent } from '../offerpackdetailmodal/cruis-detail/cruis-detail.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommentComponent } from '../comment/comment.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-offerpackcruisecard',
    templateUrl: './offerpackcruisecard.component.html',
    styleUrls: ['./offerpackcruisecard.component.scss'],
    standalone: false
})
export class OfferpackcruisecardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    @Input() offerid: string;
    @Input() reference: string;
    @Input() index: number;
    @Output() removeFromList = new EventEmitter<string>();
    @Output() changeindex = new EventEmitter<{ dragedindex: number; dropindex: number }>();

    currentpartner: Partner;
    prcdetail: string = '';
    booking: CruiseBooking;
    cabin: CruiseOfferCabin;
    currentCustomer: Customer;
    catalog: CruiseCatalog;
    realparams: CruiseOfferFIlter;

    travelerText: string = '';

    component: ComponentRef<any>;
    sendRegSub: Subscription;
    sendBook: Subscription;
    showDetail: boolean = false;
    desktopTemplate: string = 'xl';

    loading = signal<boolean>(true);

    constructor(
        private cruiseService: CruiseService,
        private authguad: AuthGuardService,
        private encservice: EncryptionService,
        private auth: AuthService,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        private viewContainerRef: ViewContainerRef,
        private router: Router,
        protected mediaObserver: BreakpointObserver,
    ) { }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        this.initPartner();
        this.initCustomer()
        this.initMedia();
    }

    async initPartner() {
        this.authguad.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.currentpartner = partner;
            if (this.currentpartner?.partnerid?.length > 0) {
                this.initData();
            }
        });
    }

    async initCustomer() {
        this.auth.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        if (Number(dragedindex) > 0 && Number(dragedindex) !== this.index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: this.index - 1 });
        }
    }

    async initData() {
        const target = {
            offerid: this.offerid,
            partnerid: this.currentpartner?.partnerid
        };
        this.cruiseService.request(target, 'getofferbyid').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res && !res.error) {
                this.cabin = res.cabin;
                this.booking = res.booking;
                this.realparams = res.realparams;
                let countEr = 1;
                let kind = 0;
                let erw = 0;
                for (let i = 0; i < this.booking?.pricedetails?.travellers.length; i++) {
                    const prc = formatNumber(Number(this.booking.pricedetails.travellers[i].total), 'de-DE', '1.2-2');
                    if (this.booking.pricedetails.travellers[i].title === 'H') {
                        this.prcdetail += countEr + '.Erwachsener ' + prc + ' EUR\n';
                        countEr++;
                        erw += 1;
                    } else {
                        this.prcdetail += countEr + '.Kinder ' + prc + ' EUR\n';
                        countEr++;
                        kind += 1;
                    }
                }
                if (erw > 0) {
                    this.travelerText = erw + ' Erwachsene';
                }
                if (kind > 0) {
                    this.travelerText += ', ' + kind + ' Kinder';
                }
                this.getCatalog();
                this.prufen();
            }
            this.cdr.detectChanges();
        });
    }

    prufen(): void {
        if (this.cabin.oid?.length > 0 && this.currentpartner?.partnerid?.length > 0) {
            this.loading.set(true);
            this.cdr.detectChanges();
            const target = {
                ref: this.currentpartner?.xt?.ref,
                cabin: this.cabin,
                realparams: this.realparams,
                partnerid: this.currentpartner?.partnerid
            };
            this.cruiseService.request(target, 'angebotprufen').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                this.booking = res.booking;
                this.loading.set(false);
                this.cdr.detectChanges();
            });
        }
    }

    async getCatalog() {
        const target = {
            sc: this.cabin?.cruise?.shipcode,
            vc: this.cabin?.cruise_provider,
            cruiseid: this.realparams?.cruise_id,
            lei: 2,
            sd: this.cabin?.cruise?.start_cruise,
            ref: this.currentpartner?.xt?.ref,
        };
        this.cruiseService.request(target, 'getcatalogdatas').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res && !res.error) {
                this.catalog = res.result as CruiseCatalog;
                this.cdr.detectChanges();
            }
        });
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid);
    }

    async goToBooking() {
        if (this.offerid?.length > 0 && this.booking?.success) {
            const target = {
                offerid: this.offerid,
                productType: 'kreuzfahrt',
                reference: this.reference
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(target) }
            };
            const url = this.router.createUrlTree(['cruise', 'cabins'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async gotoOffers() {
        this.realparams.reference = this.reference;
        const navigationExtras: NavigationExtras = {
            queryParams: { params: this.encservice.encrypt(this.realparams) }
        };
        const url = this.router.createUrlTree(['cruise', 'offers'], navigationExtras).toString();
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    async openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(CruisDetailComponent);
        this.component.instance.booking = this.booking;
        this.component.instance.cabin = this.cabin;
        this.component.instance.catalog = this.catalog;
        this.sendRegSub = this.component.instance.sendAlt.subscribe((ev) => {
            if (ev) {
                this.gotoOffers();
            }
        });
        this.sendBook = this.component.instance.sendBook.subscribe((ev) => {
            if (ev) {
                this.goToBooking();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }

    async setCommentModal() {
        let target = {} as MatDialogConfig;
        if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
            target = {
                width: '600px',
                data: {
                    title: 'Angebot Nr.' + this.index,
                    message: this.booking.extracomment
                },
                autoFocus: false
            };
        } else {
            target = {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                // panelClass: 'customModal',
                data: {
                    title: 'Angebot Nr.' + this.index,
                    message: this.booking.extracomment
                },
                autoFocus: false
            }
        }
        const resf = this.dialog.open(CommentComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data) {
                this.booking.extracomment = data?.message;
                this.saveComment(this.booking.extracomment);
            }
        });
    }

    saveComment(extracomment) {
        const target = {
            partnerid: this.currentpartner?.partnerid,
            offerid: this.offerid,
            extracomment: extracomment
        };
        this.cruiseService.request(target, 'saveComment').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                console.log(res);
            }
        });
    }
}
